import solar from "../assets/roof.jpg";
import roof from "../assets/rooftop.jpg";

export const products = [
  {
    id: 1,
    name: "Racold Solar Water Heater",
    category: "Water Heating",
    description: "High-efficiency solar water heating systems for residential and commercial use. Save up to 80% on water heating costs.",
    image: solar,
    features: ["Energy Efficient", "Low Maintenance", "Brand identity"],
    capacity: "100-500 Liters",
  },
  {
    id: 2,
    name: "Rooftop Solar Panel",
    category: "Solar Power",
    description: "Premium quality solar panels with high conversion efficiency. Perfect for residential, commercial, and industrial applications.",
    image: roof,
    features: ["25 Year Warranty", "High Efficiency", "Weather Resistant"],
    capacity: "As per Actual requirment",
  },
  {
    id: 3,
    name: "Recold Heat Pump",
    category: "HVAC",
    description: "Advanced heat pump systems for efficient heating and cooling. Reduce energy consumption by up to 75%.",
    image: "https://images.pexels.com/photos/20046691/pexels-photo-20046691.jpeg?w=800",
    features: ["Energy Saving", "Eco-Friendly", "All-Season"],
    capacity: "3-20 Ton",
  },
  {
    id: 4,
    name: "Domestic Heat Pump",
    category: "HVAC",
    description: "This high-efficiency residential heat pump delivers reliable year-round comfort while significantly reducing energy costs.",
    image: "https://racold-static.s3.ap-south-1.amazonaws.com/sites/default/files/2020-02/Heat-Pump-%281%29.png",
    features: ["Energy Saving", "Eco-Friendly", "All-Season"],
    capacity: "1–5 Ton",
  },
  {
    id: 5,
    name: "Commercial Heat Pump",
    category: "HVAC",
    description: "High-performance commercial heat pump engineered for large-scale applications such as offices, hotels, hospitals,industrial facilities & helping businesses reduce operational costs.",
    image: "https://www.racold.com/sites/default/files/inline-images/100x600_2.jpg",
    features: ["Heavy-Duty Performance", "Environment Friendly Refrigerant", "Reliable All-Weather Operation"],
    capacity: "5–50 Ton",
  },
  {
    id: 6,
    name: "Swimming Pool Heat Pump",
    category: "HVAC",
    description: "Efficient swimming pool heat pump designed to maintain optimal water temperature throughout the year. Ideal for residential and commercial pools.",
    image: "https://5.imimg.com/data5/SELLER/Default/2025/1/480237595/WT/QU/MF/4387618/swimming-pool-heat-pump-water-heater.jpg",
    features: ["All-Season Pool Heating", "Corrosion-Resistant Design", "Consistent Water Temperature"],
    capacity: "3–30 Ton",
  },
  {
    id: 7,
    name: "Water Softener",
    category: "Water Treatment",
    description: "Pureitos Brand's Advanced water softener system designed to remove hardness-causing minerals such as calcium and magnesium. Ensures a continuous supply of soft water for homes and commercial spaces.",
    image: "https://aquapureservices.in/images/products/water-softeners/1.jpg",
    features: ["Removes Hardness & Scale", "Protects Appliances & Pipelines", "Automatic Regeneration System"],
    capacity: "500–10,000 LPH",
  },
  {
    id: 8,
    name: "Pressure Pump",
    category: "Water Management",
    description: "High-performance pressure pump designed to maintain consistent water pressure across residential, commercial, and industrial applications.",
    image: "https://m.media-amazon.com/images/I/61pVmwIsOKL.jpg_BO30,255,255,255_UF750,750_SR1910,1000,0,C_QL100_.jpg",
    features: ["Constant Water Pressure", "Energy Efficient Motor", "Automatic Start & Stop"],
    capacity: "0.5–20 HP",
  },
];

export const services = [
  {
    id: 1,
    title: "Residential Solar Solutions",
    description: "Complete solar solutions for homes including rooftop solar panels, water heaters, and backup systems. Customized designs for maximum efficiency.",
    icon: "Home",
    image: "https://images.pexels.com/photos/29294301/pexels-photo-29294301.jpeg?w=800",
    features: [
      "Free Site Survey",
      "Custom Design",
      "Installation & Commissioning",
      "After-Sales Support",
      "Government Subsidy Assistance",
    ],
  },
  {
    id: 2,
    title: "Commercial & Industrial",
    description: "Large-scale solar installations for factories, warehouses, and commercial buildings. Reduce operational costs significantly.",
    icon: "Building",
    image: "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?w=800",
    features: [
      "High Capacity Systems",
      "Energy Audit",
      "ROI Analysis",
      "Turnkey Solutions",
      "Performance Monitoring",
    ],
  },
  {
    id: 3,
    title: "Hotel & Hospitality",
    description: "Specialized solar solutions for hotels and resorts. Solar water heating and power generation for reduced energy bills.",
    icon: "Hotel",
    image: "https://images.unsplash.com/photo-1635424709870-cdc6e64f0e20?w=800",
    features: [
      "Hot Water Solutions",
      "Power Backup Systems",
      "Energy Management",
      "24/7 Support",
      "Maintenance Contracts",
    ],
  },
  {
    id: 4,
    title: "Agricultural Solutions",
    description: "Solar pumping systems for irrigation and farming. Save on electricity costs and ensure reliable water supply.",
    icon: "Sprout",
    image: "https://images.pexels.com/photos/15751131/pexels-photo-15751131.jpeg?w=800",
    features: [
      "Solar Water Pumps",
      "Drip Irrigation Integration",
      "Remote Monitoring",
      "Low Maintenance",
      "Government Schemes",
    ],
  },
  {
    id: 5,
    title: "Apartments & Societies",
    description: "Community solar projects for residential complexes. Shared solar power and water heating solutions.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/34593293/pexels-photo-34593293.jpeg?w=800",
    features: [
      "Common Area Lighting",
      "Shared Solar Systems",
      "Cost Sharing Models",
      "Society Management",
      "Net Metering Setup",
    ],
  },
  {
    id: 6,
    title: "Maintenance & Support",
    description: "Comprehensive maintenance services for all solar installations. Annual maintenance contracts and emergency support.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1e5e?w=800",
    features: [
      "Regular Cleaning",
      "Performance Checks",
      "Component Replacement",
      "System Upgrades",
      "Emergency Repairs",
    ],
  },
];

export const projects = [
  {
    id: 2,
    title: "Solar Water Heating - Hotel Resort",
    category: "Hospitality",
    location: "Goa",
    capacity: "5000 LPD",
    year: "2023",
    description: "Large-scale solar water heating system for a 100-room resort. Provides hot water throughout the year.",
    image: "https://images.pexels.com/photos/34593293/pexels-photo-34593293.jpeg?w=800",
    client: "Beachside Resort & Spa",
    savings: "₹80,000/month",
  },
  {
    id: 4,
    title: "Residential Complex Solar Project",
    category: "Residential",
    location: "Belagavi, Karnataka",
    capacity: "30kW",
    year: "2023",
    description: "Community solar project for a 50-apartment complex. Powering common areas and elevators.",
    image: "https://images.pexels.com/photos/29294301/pexels-photo-29294301.jpeg?w=800",
    client: "Green Valley Apartments",
    savings: "₹35,000/month",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Shashidhar Khapali",
    role: "",
    company: "",
    image: "https://images.unsplash.com/photo-1592711491694-e85f60a7773a?w=400",
    rating: 5,
    text: "Recently bought Heat Pump, Shri Durga team installed it and it’s working fine. They provide the best quality products and after sales services always.",
    location: "Belagavi",
    type: "text",
  },
  {
    id: 2,
    name: "Madhur Miskin",
    role: "",
    company: "",
    image: "https://images.pexels.com/photos/14002570/pexels-photo-14002570.jpeg?w=400",
    rating: 5,
    text: "Best place and most reliable people to buy from Highly recommended if you're having a solar panel installed for high cost cutting solutions with respect to your electricity bills. These guys are just very good at their services and commit to their timelines.",
    location: "Belagavi",
    type: "text",
  },
  {
    id: 3,
    name: "vinod chitrali",
    role: "",
    company: "",
    image: "https://images.unsplash.com/photo-1592711491694-e85f60a7773a?w=400",
    rating: 5,
    text: "Shri Durga Enterprises – Excellent Solar Plant Installation Service. I highly recommend Shri Durga Enterprises for solar plant installation. Gajanan and his team provide exceptional end-to-end service with a strong emphasis on quality and punctuality. I installed a 15 kW solar grid, and it has been functioning flawlessly, meeting all my expectations. The service was seamless, and the team's professionalism ensured that the installation process was smooth and timely. If you're looking for reliable and efficient solar installation services, Shri Durga Enterprises is the way to go.",
    location: "Goa",
    type: "text",
  },
  {
    id: 4,
    name: "Aditya Bokade",
    role: "",
    company: "",
    image: "https://images.pexels.com/photos/14002570/pexels-photo-14002570.jpeg?w=400",
    rating: 5,
    text: "I have been using the service of Mr. Gajanan. Prompt service and premium quality work.",
    location: "Belagavi",
    type: "text",
  },
  {
    id: 5,
    name: "Rahul Aptekar",
    role: "",
    company: "",
    image: "https://images.unsplash.com/photo-1592711491694-e85f60a7773a?w=400",
    rating: 5,
    text: "Very very good quality product and The best service",
    location: "Belagavi",
    type: "text",
  },
];

export const videoTestimonials = [
  {
    id: 1,
    name: "Kumar Family",
    title: "Residential Solar Success Story",
    thumbnail: "https://images.unsplash.com/photo-1639135723583-5c84eb8b6198?w=600",
    instagramUrl: "https://www.instagram.com/reel/placeholder1",
    description: "Watch how Kumar family reduced their electricity bills by 80% with our solar solution",
    location: "Belagavi",
  },
  {
    id: 2,
    name: "ABC Manufacturing",
    title: "Industrial Solar Installation",
    thumbnail: "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?w=600",
    instagramUrl: "https://www.instagram.com/reel/placeholder2",
    description: "50kW rooftop solar installation transforming their energy costs",
    location: "Karnataka",
  },
  {
    id: 3,
    name: "Green Valley Apartments",
    title: "Community Solar Project",
    thumbnail: "https://images.pexels.com/photos/29294301/pexels-photo-29294301.jpeg?w=600",
    instagramUrl: "https://www.instagram.com/reel/placeholder3",
    description: "How 50 families are benefiting from shared solar power",
    location: "Belagavi",
  },
  {
    id: 4,
    name: "Hotel Beachside",
    title: "Commercial Solar Water Heating",
    thumbnail: "https://images.pexels.com/photos/34593293/pexels-photo-34593293.jpeg?w=600",
    instagramUrl: "https://www.instagram.com/reel/placeholder4",
    description: "5000 LPD solar water heating system serving 100-room resort",
    location: "Goa",
  },
];

export const stats = [
  { number: "5000+", label: "Projects Completed", icon: "CheckCircle" },
  { number: "20", label: "Years Experience", icon: "Award" },
  { number: "2,75000", label: "Tons CO₂ Saved", icon: "Leaf" },
  { number: "100%", label: "Customer Satisfaction", icon: "ThumbsUp" },
];

export const contactInfo = {
  name: "Shri Durga Enterprises",
  address: "Shop No. G3/1, Sairaj Empire, Roy Rd, Shivaji Colony, Tilakwadi, Belagavi, Karnataka 590006",
  phone: "07026303999",
  email: "info@sdesolarenergies.com",
  instagram: "https://www.instagram.com/shri_durga_enterprises_/",
  caption: "🔋 Solar Water Heaters | Heat Pumps | Rooftop Solar\n🌍 Powering a Sustainable Future\n💡 Tailored Solar Solutions\n📞 DM for Consultations & Inquiries",
  workingHours: "Mon - Sat: 10:00 AM - 8:00 PM",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.3837393240115!2d74.49776520931418!3d15.836416184746454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf67b97cf5c863%3A0xb1b957193fc439cc!2sShri%20Durga%20Enterprises!5e0!3m2!1sen!2sin!4v1770344744348!5m2!1sen!2sin",
  serviceAreas: ["Belagavi", "Karnataka", "Goa"],
};
